import { render } from "./ViewPayrollEmployeeConfig.vue?vue&type=template&id=ef91ebaa"
import script from "./ViewPayrollEmployeeConfig.vue?vue&type=script&lang=js"
export * from "./ViewPayrollEmployeeConfig.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__